
import { useState } from "react"
import img from "../../styles/img/midiDeal/drinks.png"
import iconInfo from "../../styles/img/midiDeal/iconInfo.svg"
import { MidiDealDrawer } from "./MidiDealDrawer";
import { useSelector } from "react-redux";
import useAxios from "../../axios/useAxios";
import { getMidiDealProducts, logMidiDealEvent } from "../../actions/midiDealActions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { formatPriceWithEuro } from "../../utils/StringUtils";

export const MidiDealHomeCard = () => {
  const { products, loading, error } = useSelector((state) => state.midiDeal);
  const { store } = useSelector((state) => state.store);
  const { order } = useSelector((state) => state.orderDetails);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const axiosInstance = useAxios();
  const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getMidiDealProducts(store.id, axiosInstance));
    }, [axiosInstance, store.id]);

  if (!store?.midiDeal) return null;

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
    dispatch(logMidiDealEvent(axiosInstance, {
      event: 'midideal.ui.prompt_shown',
      orderId: order?._id,
      storeId: store.id,
      midiDealData: {
        dealPrice: store.midiDeal?.dealPrice,
        timeSlot: store.midiDeal?.timeSlot,
        dealActive: products?.dealActive,
        availableProducts: {
          main: products?.main?.count ?? 0,
          snack: products?.snack?.count ?? 0,
          drink: products?.drink?.count ?? 0,
        },
      },
    }));
  };

    return (
        <div className="flex items-start text-black geomanistMedium text-[18px] flex-col gap-4">
            <p>
                En ce moment
            </p>
            <button
                role="button"
                tabIndex={0}
                className="flex justify-between relative items-start bg-white rounded-3xl p-8 border border-gray-200 active:border-[#f3d349ff] active:scale-[0.98] transition-all duration-200 cursor-pointer"
                onClick={handleOpenDrawer}
                onKeyDown={(e) => e.key === "Enter" && handleOpenDrawer()}
            >
                <div className="flex justify-end w-full absolute top-4 right-4">
                    <img src={iconInfo} alt="iconInfo" />
                </div>
                <div className="flex flex-col h-full justify-top gap-4">
                    <div className="flex justify-start w-full gap-4">
                        <p className="geomanistBook font-bold text-[16px]">Midi Deal</p>
                        <span className="relative geomanistBold text-[20px]" style={{ letterSpacing: "2px" }}>
                            <span
                                className="absolute inset-0"
                                style={{
                                    WebkitTextStroke: "3px #C89825",
                                    color: "transparent"
                                }}
                            >{formatPriceWithEuro(store.midiDeal.dealPrice)}</span>
                            <span
                                style={{
                                    background: "linear-gradient(107.64deg, #f3d349ff 64.66%, #F19F10 100.98%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    backgroundClip: "text",
                                    position: "relative",
                                    filter: "drop-shadow(1px 2px 0px #C89825)"
                                }}
                            >{formatPriceWithEuro(store.midiDeal.dealPrice)}</span>
                        </span>
                    </div>
                    <p className="geomanistRegular text-left font-bold text-[14px]">
                        1 principal, 1 snack et 1 boisson
                    </p>
                </div>
                <div className="flex justify-right h-[78px]">
                    <img src={img} alt="boisson" />
                </div>
            </button>

            <MidiDealDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} products={products} loading={loading} error={error} />
        </div>
    );
};
